export interface Step {
    label: string;
    status: string;
    visible: boolean;
    value: number;
    icon: string;
}
export const steps: Step[] = [
    { label: 'Order Info', status: 'none', visible: true, value: 1, icon: 'icomoon-order-info' },
    { label: 'Subjects', status: 'none', visible: true, value: 2, icon: 'icomoon-subjects' },
    { label: 'Subpoena', status: 'none', visible: false, value: 3, icon: 'icomoon-subpoena' },
    { label: 'Authorization', status: 'none', visible: false, value: 4, icon: 'icomoon-subpoena' },
    { label: 'Records', status: 'none', visible: true, value: 5, icon: 'icomoon-records' }
];

export const states = [
    { name: 'California', value: 'CA' },
    { name: 'Texas', value: 'TX' },
    { name: 'Florida', value: 'FL' },
    { name: 'New Jersey', value: 'NJ' }
  ];

export enum PartyTypeCode {
    Person = 'Person',
    Organization = 'Organization',
    Anonymous = 'Anonymous'
}

export enum PartyRoleCode {
    Paralegal = 'paralegal',
    Other = 'other',
    Attorney = 'attorney',
    PlaintiffAttorney = 'plaintiff-attorney',
    Defendant = 'defendant',
    BillTo = 'bill-to',
    DeliverTo = 'deliver-to',
    RecordSubject = 'record-subject',
    Court = 'court',
    RecordsCustodian = 'records-custodian',
    MedicalProvider = 'medical-provider',
    AmbulanceService = 'ambulance-service',
}

export interface Document {
    storageId: string;
    storageProviderId: string;
    contentType: string;
    fileName: string;
    displayName: string;
    description: string;
    sizeBytes: number;
    sizeText: string;
  }
  
export  interface Attachment {
    attachTo: string;
    document: Document;
    tagNames: string[];
  }
  